import { isNullOrUndefined } from "@qntm-code/utils";
import { CalendarType } from "@app/shared/enums/calendar-type.enum";
import { FrequencyType } from "@app/shared/enums/frequency-type.enum";

export class CalendarEvent {
  // standard full calendar attributes
  id: number;
  title: string;
  description?: string;
  start: string;
  end?: string;
  startLastDayOfMonth?: boolean;
  allDay?: boolean;
  partialClose?: boolean;

  // onelynk specific attributes
  groupId?: number;
  subtype?: CalendarType;
  frequency?: FrequencyType;
  year?: string;                        // required for certain fiance calendars
  period?: number;
  version?: number;

  secondStart?: number;

  inherited?: boolean;
  overridable?: boolean;
  orgId?: number;
  payrollPeriodOffset?: number;
  currentPeriod?: boolean;
  startPeriodNumber?: number;
}

export class CalendarInfoFrequency {
  // single value of second start
  secondStart: number;

  // frequency options
  accountingFrequencies: FrequencyType[];
  targetFrequencies: FrequencyType[];

  // min and max calendar
  accountingStart?: string;
  accountingEnd?: string;
  orgBillingStart?: string;

  // calculating this year's first timesheet period's start date, payroll period's start date, and payrollPeriodOffset
  timesheetStart?: string;
  payrollStart?: string;
  payrollPeriodOffset?: number;

  // showing start date for next year's periods
  payableNewYearStart?: string;
  invoicingNewYearStart?: string;
  timesheetNewYearStart?: string;
  payrollNewYearStart?: string;
  payrollFrequency?: FrequencyType;
  timesheetFrequency?: FrequencyType;

  // displaying start date or payrollPeriodOffset
  inNextYear?: boolean = false;

  // show fiscal year or just year
  inFiscalYear?: boolean = false;
  fiscalStartMonth?: string;
}

export enum AllFrequency {
  Weekly = "WEEKLY",
  BiWeekly = "BI_WEEKLY",
  Monthly = "MONTHLY",
  SemiMonthly = "SEMI_MONTHLY",
  Quarterly = "QUARTERLY",
  Annually = "ANNUALLY",
  FourFourFive = "FOUR_FOUR_FIVE",
}

export enum EventFrequency {
  Weekly = "WEEKLY",
  BiWeekly = "BI_WEEKLY",
  Monthly = "MONTHLY",
  SemiMonthly = "SEMI_MONTHLY",
  FourFourFive = "FOUR_FOUR_FIVE",
  Quarterly = "QUARTERLY",
  Annually = "ANNUALLY"
}

export enum AccountingFrequency {
  FourFourFive = "FOUR_FOUR_FIVE",
  Monthly = "MONTHLY",
}

export enum CalendarView {
  TimeGridWeek = "timeGridWeek",
  TimeGridDay = "timeGridDay",
  ListWeek = "listWeek",
  ListYear = "listYear",
  DayGridMonth = "dayGridMonth",
}

export class CalendarParam {
  subtype: CalendarType;
  start: string;
  end: string;
  frequency: FrequencyType;
  title: string;
  year: string;

  constructor (calendar?: CalendarEvent) {
    if (!isNullOrUndefined(calendar)) {
      this.subtype = calendar.subtype;
      this.start = calendar.start;
      this.end = calendar.end;
      this.frequency = calendar.frequency;
      this.title = calendar.title;
      // this.year = calendar.year;
    }
  }
}

export class Calendar {
  id?: number;
  version?: number;

  groupId: number;
  subtype: CalendarType;
  frequency: FrequencyType;
  title: string;
  description: string;
  period: number;
  start: string;
  end: string;
  startAt: string;
  endAt: string;
  year: string;
  periodClosed?: boolean;
  yearClosed?: boolean;

  inherited: boolean;
  overridable: boolean;

  orgId: number;
  orgName: string;
  periodAsString?: string;
}
